import axios from 'axios';
import {
  EVENTS_LOAD_PROJECT_DETAIL_EVENT_BEGIN,
  EVENTS_LOAD_PROJECT_DETAIL_EVENT_SUCCESS,
  EVENTS_LOAD_PROJECT_DETAIL_EVENT_FAILURE,
  EVENTS_LOAD_PROJECT_DETAIL_EVENT_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadProjectDetailEvent(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EVENTS_LOAD_PROJECT_DETAIL_EVENT_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: EVENTS_LOAD_PROJECT_DETAIL_EVENT_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: EVENTS_LOAD_PROJECT_DETAIL_EVENT_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadProjectDetailEventError() {
  return {
    type: EVENTS_LOAD_PROJECT_DETAIL_EVENT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EVENTS_LOAD_PROJECT_DETAIL_EVENT_BEGIN:
      return {
        ...state,
        loadProjectDetailEventPending: true,
        loadProjectDetailEventError: null,
      };

    case EVENTS_LOAD_PROJECT_DETAIL_EVENT_SUCCESS:
      return {
        ...state,
        loadProjectDetailEventPending: false,
        loadProjectDetailEventError: null,
        projectDetail: action.data,
      };

    case EVENTS_LOAD_PROJECT_DETAIL_EVENT_FAILURE:
      return {
        ...state,
        loadProjectDetailEventPending: false,
        loadProjectDetailEventError: action.data.error,
      };

    case EVENTS_LOAD_PROJECT_DETAIL_EVENT_DISMISS_ERROR:
      return {
        ...state,
        loadProjectDetailEventError: null,
      };

    default:
      return state;
  }
}
